import { render, staticRenderFns } from "./performance-summary-report.vue?vue&type=template&id=307ace10&scoped=true&"
import script from "./performance-summary-report.vue?vue&type=script&lang=js&"
export * from "./performance-summary-report.vue?vue&type=script&lang=js&"
import style0 from "./performance-summary-report.vue?vue&type=style&index=0&id=307ace10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307ace10",
  null
  
)

export default component.exports